const DsmSensitivity: { [key: string]: string } = {
  "0": "Low",
  "1": "Medium",
  "2": "High_2",
};

export default DsmSensitivity;
